module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-t-mobile-02@2x.f440be8f.jpg";